import { For, Show } from "solid-js";
import { useListLinksWidget } from "../../../providers/links/context";
import { ListSection } from "../Section";

export function Root() {
	const { list } = useListLinksWidget();

	return (
		<div class="flex flex-col gap-y-8">
			<Show when={list()}>
				{(list) => (
					<For each={list().sections}>
						{(section) => (
							<ListSection
								section={section}
								appearance={list().appearance}
							/>
						)}
					</For>
				)}
			</Show>
		</div>
	);
}
